import React from 'react';
import { string, func, bool } from 'prop-types';

import { replaceTags } from '../util/messages';

import Notice from './Notice';

const icons = { error: 'error_outline', success: 'check_circle', info: 'info', tip: 'lightbulb' };

// Status line: errors and results of actions as notices, tips as a quiet grey line
const Status = ({
  message,
  type,
  removeTip,
  nightModeEnabled,
  openWhyPremiumDialog,
  openOptionsDialog
}) => {
  if (!message) {
    return null;
  }
  const text = replaceTags(message, openWhyPremiumDialog, openOptionsDialog);
  const tone = type === 'error' ? 'error' : type === 'tip' ? 'tip' : 'info';

  return (
    <Notice
      id="status-message"
      tone={tone}
      icon={icons[type] || 'info'}
      onClose={type === 'tip' ? removeTip : null}
      nightModeEnabled={nightModeEnabled}
      style={{ marginTop: 12 }}
    >
      {type === 'tip' ? (
        <span>
          <b style={{ fontWeight: 500 }}>Tip: </b>
          {text}
        </span>
      ) : (
        text
      )}
    </Notice>
  );
};

Status.propTypes = {
  message: string,
  type: string,
  removeTip: func,
  nightModeEnabled: bool,
  openWhyPremiumDialog: func,
  openOptionsDialog: func
};

export default Status;
